import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Action } from '@atlassian/react-sweet-state';
import type {
	ObjectActivityTimelineState,
	ContainerProps,
} from '../../../../common/types/store.tsx';
import type { TimelineEvent } from '../../../../common/types/timeline-event.tsx';
import { deleteObjectComment as deleteObjectCommentService } from '../../../../services/object-activity/index.tsx';

export const deleteObjectComment =
	({
		commentId,
		onSuccess,
		onFailure,
	}: {
		commentId: string;
		onSuccess: () => void;
		onFailure: (error: string) => void;
	}): Action<ObjectActivityTimelineState, ContainerProps> =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const serviceResponse = await deleteObjectCommentService({
			workspaceId,
			commentId,
		});

		// An empty response indicates the delete request was successful
		if (serviceResponse == null) {
			const latestTimelineEvents: TimelineEvent[] = getState().timelineEvents ?? [];
			setState({
				timelineEvents: [
					...latestTimelineEvents.filter((timelineEvent) => timelineEvent.data.id !== commentId),
				],
			});
			fireTrackAnalytics(createAnalyticsEvent({}), 'deleteObjectComment succeeded');
			onSuccess();
		} else {
			onFailure(serviceResponse.error);
			fireErrorAnalytics({
				error: serviceResponse.rawError,
				meta: {
					id: 'deleteObjectComment',
					packageName: 'jiraServicedeskInsightObjectActivityTimelineStore',
					teamName: 'falcons',
				},
				attributes: {
					errorType: serviceResponse.error,
					errorMessage: serviceResponse.rawError.message,
				},
			});
		}
	};
